import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, resolveDirective as _resolveDirective, createVNode as _createVNode, withDirectives as _withDirectives, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "help-slot-rule-popup" }
const _hoisted_2 = { class: "popup-main" }
const _hoisted_3 = { class: "popup-header flex flex-column justify-center" }
const _hoisted_4 = ["innerHTML"]

import { ref, onMounted } from 'vue';


export default {
  __name: 'Rule',
  emits: ['onClose'],
  setup(__props, { emit: __emit }) {

const emit = __emit

const ruleContent = ref('');

onMounted(() => {
  ruleContent.value = 'Comprehensive Real-Time Data:<br/><br/>' 
    + 'HelpSlot - Jackpot Monitoring App<br/><br/>' 
    + 'Comprehensive Real-Time Data:<br/><br/>'
    + 'Arrow Up <span class="green">(Green)</span> = Jackpot is increasing<br/>'
    + 'Arrow Down <span class="red">(Red)</span> = Jackpot is paying out<br/><br/>'
    + 'Use this data to determine the best time to enter and place your bets.';
})

return (_ctx, _cache) => {
  const _component_van_icon = _resolveComponent("van-icon")
  const _component_van_popup = _resolveComponent("van-popup")
  const _directive_audio = _resolveDirective("audio")

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_van_popup, {
      show: true,
      "close-on-click-overlay": false
    }, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[1] || (_cache[1] = _createElementVNode("div", { class: "popup-title" }, _toDisplayString('HelpSlot'), -1)),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "popup-subtitle" }, _toDisplayString('Jackpot Monitoring Assistant'), -1)),
            _withDirectives(_createVNode(_component_van_icon, {
              class: "close-icon",
              name: "close",
              onClick: _cache[0] || (_cache[0] = $event => (emit('onClose')))
            }, null, 512), [
              [_directive_audio, void 0, "close"]
            ])
          ]),
          _createElementVNode("div", {
            class: "popup-content",
            innerHTML: ruleContent.value
          }, null, 8, _hoisted_4)
        ])
      ]),
      _: 1
    })
  ]))
}
}

}